import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AiFillDelete } from 'react-icons/ai';
import { removeFromCart, updateQuantity, addToCart } from '../store/reducers/cartSlice';
import { Link } from 'react-router-dom';
import { Card, Button, Row, Col, Divider, Empty, message } from 'antd';
import Meta from '../ass_components/Meta';
import BreadCrumb from '../ass_components/BreadCrumb';
import { useNavigate } from "react-router-dom";

const suggestedProducts = [
  {
    id: 1,
    product_title: 'Soja jaune sec',
    image1: 'images/detail-images/detail1.jpg',
    price: 750,
  },
  {
    id: 2,
    product_title: 'Patate douce bio',
    image1: 'images/detail-images/detail4.jpg',
    price: 900,
  },
];

const Cart = () => {
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.cart);
  const [showSuggestions, setShowSuggestions] = useState(true);
    const navigate = useNavigate();
    const isAuthenticated = () => {
        const token = localStorage.getItem("token");
        return !!token;
    };
    const subtotal = items.reduce((acc, item) => acc + item.price * item.quantity, 0);

    /*
     * Un seul parcours d'achat Marketplace : demande au vendeur -> offre ->
     * accord -> livraison + paiement (Mon compte > Notifications).
     * Le panier ne déclenche plus de paiement direct.
     */
    const handleCheckoutClick = () => {
        if (!isAuthenticated()) {
            message.warning("Veuillez vous connecter pour continuer");
            navigate("/login");
            return;
        }
        navigate("/account?tab=notifications");
    };

  const handleAddSuggested = (product) => {
    dispatch(addToCart({ ...product, quantity: 1 }));
    message.success(`${product.product_title} ajouté au panier.`);
  };

  const handleQuantityChange = (id, quantity) => {
    dispatch(updateQuantity({ id, quantity: Number(quantity) }));
  };

  const handleRemove = (id) => {
    dispatch(removeFromCart(id));
  };

  return (
    <>
      <Meta title="Panier" />
      <BreadCrumb title="Votre Panier" />
      <div className="container-xxl py-5">
        <div className="row">
          <div className="col-12">
            {items.length === 0 && showSuggestions ? (
              <>
                {/* <Empty description="Votre panier est vide" /> */}
                <div className='text-center mt-5'>
                  <h3>🛒 Votre panier est vide</h3>
                  <p>Découvrez nos produits :</p>
                  <Link to="/resellers" className="button mt-3">Explorer les produits</Link>
                </div>
                <Divider />
                <h4>Produits suggérés :</h4>
                <Row gutter={[16, 16]}>
                  {suggestedProducts.map((prod) => (
                    <Col xs={24} sm={12} md={8} key={prod.id}>
                      <Card
                        hoverable
                        cover={<img src={prod.image1} alt={prod.product_title} className="img-fluid" />}
                        actions={[
                          <Button className="application-button" onClick={() => handleAddSuggested(prod)}>Ajouter au panier</Button>,
                          <Button danger onClick={() => setShowSuggestions(false)}>Ignorer</Button>,
                        ]}
                      >
                        <Card.Meta title={prod.product_title} description={`${prod.price} XOF`} />
                      </Card>
                    </Col>
                  ))}
                </Row>
              </>
            ) : items.length === 0 ? (
              <Empty description="Votre panier est vide" />
            ) : (
              <>
                <div className="cart-header py-3 d-flex justify-content-between align-items-center">
                  <h4 className="cart-col-1">Produit</h4>
                  <h4 className="cart-col-2">Prix</h4>
                  <h4 className="cart-col-3">Quantité</h4>
                  <h4 className="cart-col-4">Total</h4>
                </div>
                {items.map((item) => (
                  <div key={item.id} className="cart-data mb-2 py-3 d-flex justify-content-between align-items-center">
                    <div className="cart-col-1 gap-15 d-flex align-items-center">
                      <div className="w-30">
                        <img src={item.image1} className="img-fluid" alt={item.product_title} />
                      </div>
                      <div className="w-70">
                        <p>{item.product_title}</p>
                      </div>
                    </div>
                    <div className="cart-col-2">
                      <h5 className="price">{item.price} XOF</h5>
                    </div>
                    <div className="cart-col-3">
                      <input
                        type="number"
                        min={1}
                        value={item.quantity}
                        onChange={(e) => handleQuantityChange(item.id, e.target.value)}
                        style={{ width: '60px' }}
                        className="form-control"
                      />
                    </div>
                    <div className="cart-col-4 d-flex justify-content-between align-items-center">
                      <h5 className="price mb-0">{item.price * item.quantity} XOF</h5>
                      <AiFillDelete onClick={() => handleRemove(item.id)} className="text-danger fs-5" />
                    </div>
                  </div>
                ))}

                <div className="col-12 d-flex justify-content-between py-2 mt-4">
                  <Link to="/resellers">Continuer vos achats</Link>
                  <div className="d-flex flex-column align-items-end">
                    <h4>Total : {subtotal} XOF</h4>
                    <p>Toutes taxes incluses</p>
                      <p className="text-muted mb-2" style={{ maxWidth: 420, textAlign: "right" }}>
                          {"Le paiement s'effectue après accord avec le vendeur : ouvrez une demande depuis "
                              + "la fiche produit, puis réglez l'accord depuis votre espace."}
                      </p>
                      <Button
                          type="primary"
                          className="button"
                          onClick={handleCheckoutClick}
                      >
                          Voir mes accords et paiements
                      </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Cart;
